export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.25 5.75a2 2 0 100 4 2 2 0 000-4zM5.813 8.5h.018a3.501 3.501 0 006.838 0h7.58a.75.75 0 000-1.5h-7.58a3.501 3.501 0 00-6.838 0H3.75a.75.75 0 100 1.5h2.062zM18.169 17a3.501 3.501 0 01-6.839 0H3.751a.75.75 0 110-1.5h7.562a.54.54 0 01.018 0 3.5 3.5 0 016.838 0H20.249a.75.75 0 010 1.5H18.17zm-5.42-.75a2 2 0 114 0 2 2 0 01-4 0z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};